import { videos } from '@/mocks/homeData';
import VideoCard from '@/pages/home/components/VideoCard';

export default function NewestSection() {
  const newestVideos = [...videos]
    .sort((a, b) => new Date(b.date).getTime() - new Date(a.date).getTime())
    .slice(0, 8);

  return (
    <section className="py-10 md:py-14 bg-background-100/50">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="mb-6">
          <h2 className="text-xl md:text-2xl font-bold text-foreground-950 font-heading">最新上线</h2>
          <p className="text-sm text-foreground-600 mt-1">刚刚更新的新鲜内容</p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {newestVideos.map((video) => (
            <VideoCard key={video.id} video={video} />
          ))}
        </div>
      </div>
    </section>
  );
}